// extracted by mini-css-extract-plugin
export var dataForm = "filmVault-module--dataForm--d45e6";
export var klaviyoForm = "filmVault-module--klaviyoForm--c33d8";
export var linkToIndex = "filmVault-module--linkToIndex--73b9c";